// extracted by mini-css-extract-plugin
module.exports = {"list":"ClientPrograms_list__zwnLs","listExternal":"ClientPrograms_listExternal__2R5DT"};